import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Home from '../views/Home.vue'
// import IPWhiteList from '../views/IPWhiteList.vue'
import ApiService from '../services/ApiService'
import ability from '@/services/Ability';

Vue.use(VueRouter)

const ifCan = (to, from, next) => {
  if  (!store.getters.isAuthenticated){
    next({ name: 'Login', params: { returnUrl: to } })
  }
  else if (!ability.can(to.meta.action, to.meta.subject)){
    Vue.$toast.error('You are not allowed to access this page');
    next({ name: 'Home' });
    return;
  }
  else{
    next();
    return;
  }
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next({ name: 'Login', params: { returnUrl: to } })
}

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next({ name: 'Home' })
}

const activateTicket = (to, from, next) => {
  ApiService.activateTicket(to.query.ticketId)
    .then(resp => {
      switch (resp.data.authenticationMethod) {
        case 0:
          next({ name: 'SSOAAD' });
          break;
        case 3:
        default:
          next({ name: 'Authenticate', params: { email: resp.data.email, skipFilter: true } });
          break;
      }
      
    })
}

const getImage = (to, from, next) => {
  // console.log('image')
  return ApiService.getImage(to.query.fileName)
    .then(resp => { console.debug(resp.data); next() })
}

const unlock = (to, from, next) => {
  ApiService.releaseAllLocksForUser()
    .then(() => {
      next();
      return;
    })
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      action: 'ESVOverview',
      subject: 'Home',
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/overview',
    name: 'Overview',
    component: () => import('../views/Documents/Overview.vue'),
    meta: {
      action: 'ESVOverview',
      subject: 'Home',
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/inprogress',
    name: 'InProgress',
    component: () => import('../views/Input/InProgress.vue'),
    meta: {
      action: 'Overview',
      subject: 'InProgress'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/tobeapproved',
    name: 'ToBeApproved',
    component: () => import('../views/Publish/ToBeApproved.vue'),
    meta: {
      action: 'Overview',
      subject: 'ToBeApproved'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/tobedistributed',
    name: 'ToBeDistributed',
    component: () => import('../views/Publish/ToBeDistributed.vue'),
    meta: {
      action: 'Overview',
      subject: 'ToBeDistributed',
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/underpreparation',
    name: 'UnderPreparation',
    component: () => import('../views/Documents/UnderPreparation.vue'),
    meta: {
      action: 'Overview',
      subject: 'UnderPreparation',
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/translations',
    name: 'Translations',
    component: () => import('../views/Translations/Translations.vue'),
    meta: {
      action: 'Overview',
      subject: 'Translations',
    },
    props: true,
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/translations/:id/:selectedCultureId?',
    name: 'UpdateTranslation',
    component: () => import('../views/Translations/Update.vue'),
    props: true,
    meta: {
      action: 'Overview',
      subject: 'Translations',
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/esv/:esvId',
    name: 'ESV',
    props: true,
    component: () => import('../views/ESV.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/create',
    name: 'Create',
    component: () => import('../views/Input/Create.vue'),
    meta: {  
      action: 'Create',
      subject: 'Navbar'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/publish/:esvId',
    name: 'Publish',
    props: true,
    component: () => import('../views/Publish/Publish.vue'),
    beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next); unlock(to, from, next); }
  },
  // {
  //   path: '/ipwhitelist',
  //   name: 'IPWhiteList',
  //   component: IPWhiteList,
  //   meta: {  
  //     action: 'Overview',
  //     subject: 'IPWhiteList'
  //   },
  //   beforeEnter: ifCan
  // },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Authentication/UserName.vue'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/sso-aad',
    name: 'SSOAAD',
    component: () => import('../views/Authentication/SSOAAD.vue'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/login/:email',
    name: 'Authenticate',
    component: () => import('../views/Authentication/Login.vue'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/LoginOptions',
    name: 'LoginOptions',
    component: () => import('../views/Authentication/LoginOptions.vue'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/Users.vue'),
    meta: {
      action: 'Overview',
      subject: 'Profile'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/users/update/:userId',
    name: 'Users/Update',
    component: () => import('../views/Administration/Users/Update.vue'),
    props:  true,
    meta: {
      action: 'Overview',
      subject: 'Profile'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/users/profile',
    name: 'Users/Profile',
    component: () => import('../views/Administration/Users/Profile.vue'),
    props:  true,
    beforeEnter: unlock
  },
  {
    path: '/users/create',
    name: 'Users/Create',
    component: () => import('../views/Administration/Users/Create.vue'),
    props:  true,
    meta: {
      action: 'Overview',
      subject: 'Profile'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/organisations',
    name: 'Organisations',
    component: () => import('../views/Administration/Organisations/Organisations.vue'),
    meta: {
      action: 'Overview',
      subject: 'Organisation'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/organisations/update/:organisationId',
    name: 'Organisations/Update',
    component: () => import('../views/Administration/Organisations/Update.vue'),
    props:  true,
    meta: {
      action: 'Overview',
      subject: 'Organisation'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/organisations/create',
    name: 'Organisations/Create',
    component: () => import('../views/Administration/Organisations/Create.vue'),
    props:  true,
    meta: {
      action: 'Overview',
      subject: 'Organisation'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/parts',
    name: 'Parts',
    component: () => import('../views/Administration/Parts/Parts.vue'),
    meta: {
      action: 'Overview',
      subject: 'Part'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/parts/Update/:partId',
    name: 'Parts/Update',
    component: () => import('../views/Administration/Parts/Update.vue'),
    props:  true,
    meta: {
      action: 'Overview',
      subject: 'Part'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/serviceRequestTypes',
    name: 'ServiceRequestTypes',
    component: () => import('../views/Administration/ServiceRequestTypes/ServiceRequestTypes.vue'),
    meta: {
      action: 'Overview',
      subject: 'ServiceRequestType'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/serviceRequestTypes/Update',
    name: 'ServiceRequestTypes/Update',
    component: () => import('../views/Administration/ServiceRequestTypes/Update.vue'),
    meta: {
      action: 'Overview',
      subject: 'ServiceRequestType'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/logAlternativeLogins',
    name: 'LogAlternativeLogins',
    component: () => import('../views/Administration/LogAlternativeLogins/LogAlternativeLogins.vue'),
    meta: {
      action: 'Overview',
      subject: 'AlternativeLogins'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/lockedESV',
    name: 'LockedESV',
    component: () => import('../views/Administration/LockedESV/LockedESV.vue'),
    meta: {
      action: 'Overview',
      subject: 'LockedESV'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/advancedSearch',
    name: 'AdvancedSearch',
    component: () => import('../views/Search/SearchAdvanced.vue'),
    meta: {
      action: 'GeneralSearch',
      subject: 'AdvancedSearch'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/serialSearch',
    name: 'SerialSearch',
    component: () => import('../views/Search/SearchSerial.vue'),
    meta: {
      action: 'SerialSearch',
      subject: 'SerialNr'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/dynamicSearch',
    name: 'DynamicSearch',
    component: () => import('../views/Search/SearchDynamic.vue'),
    props:  true,
    beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/models',
    name: 'Models',
    component: () => import('../views/Administration/Models/Overview.vue'),
    meta: {
      action: 'Overview',
      subject: 'Model'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/models/:id',
    name: 'EditModel',
    component: () => import('../views/Administration/Models/Edit.vue'),
    props: true,
    meta: {
      action: 'Overview',
      subject: 'Model'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/accessdenied',
    name: 'IPAuthenticationRequest',
    component: () => import('../views/Authentication/IPAuthenticationRequest.vue'),
  },
  {
    path: '/lostpassword',
    name: 'LostPassword',
    component: () => import('../views/Authentication/ResetPasswordRequest.vue'),
  },
  {
    path: '/resetpassword/:hash',
    name: 'ResetPassword',
    props: true,
    component: () => import('../views/Authentication/ResetPassword.vue'),
  },
  {
    path: '/setpassword/:accessKey',
    name: 'SetPassword',
    props: true,
    component: () => import('../views/Authentication/SetPassword.vue'),
  },
  {
    path: '/copy/:id?',
    name: 'Copy',
    component: () => import('../views/Input/Copy.vue'),
    props: true,
    meta: {
      action: 'Copy',
      subject: 'Navbar'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/esvsituations',
    name: 'ESVSituations',
    component: () => import('@/views/Input/ESVSituations'),
    props: true,
    meta: {
      action: 'Overview',
      subject: 'ESVSituations'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/approvalvalidation/:esvId',
    name: 'ApprovalValidation',
    props: true,
    component: () => import('@/views/Input/ApprovalValidation'),
    meta: {
      action: 'Approve',
      subject: 'ESV'
    },
    beforeEnter: ifCan
  },
  {
    path: '/activateticket',
    beforeEnter: activateTicket
  },
  {
    path: '/images/:fileName',
    beforeEnter: getImage
  },
  {
    path: '/Help',
    name: 'Help',
    component: () => import('../views/Help.vue'),
    meta: {
      action: 'Help',
      subject: 'Help'
    },
    beforeEnter: unlock
  },
  {
    path: '/LoggedUpdates',
    name: 'LoggedUpdates',
    component: () => import('../views/Analytics/LoggedUpdates.vue'),
    meta: {
      action: 'Overview',
      subject: 'Analytics'
    },
    beforeEnter: (to, from, next) => { ifCan(to, from, next); unlock(to, from, next); }
  },
  {
    path: '/googleanalytics',
    name: 'GoogleAnalytics',
    beforeEnter: (to, from, next) => {
      window.open('https://analytics.google.com/analytics/web/#/p417123676/reports/reportinghub', '_blank');
      next(false); // Cancel the navigation
    }
  },
  {
    path: '/ReleaseNotes',
    name: 'ReleaseNotes',
    component: () => import('../views/ReleaseNotes.vue'),
    beforeEnter: unlock
  },
  {
    path: '/communicationRules',
    name: 'CommunicationRules',
    component: () => import('../views/ECare/CommunicationRules.vue')
  },
{
  path: '/addrule/:ruleId?',
    name: 'AddRule',
    props: true,                  
    component: () => import('../views/ECare/AddRule.vue'),
    //beforeEnter: ifAuthenticated  // optioneel, als je wilt dat alleen ingelogde users dit kunnen
  },
  {
  path: '/ecarelogs',
  name: 'ECareLogs',
  component: () => import('../views/ECare/ECareLogs.vue'),
},
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  Vue.$gtag.event(to.name, { method: 'Router' });
  next();
});


export default router
